import * as React from "react";

import {FontAwesomeIcon}     from "@fortawesome/react-fontawesome";
import {faExclamationCircle} from "@fortawesome/free-solid-svg-icons";
import {cx}                  from "emotion";

import {cs}             from "@Common/react/chain-services";
import {CountdownTimer} from "@Common/react/countdown-timer";

const DAY_MILLISECONDS = 86400000; // promo codes expire at end of day

export const PromoCodeAlert = ({code, expiry}:{
    code    : string,
    expiry  : Date,
}) => cs(
    ["countdown", ({}, next) => CountdownTimer({countdownTo: new Date(expiry.valueOf() + DAY_MILLISECONDS), refreshFrequency: 60000, next})],
    ["expired", ({countdown}, next) => next(countdown.hours === undefined)],
    ({countdown, expired}, next) => (
        <i
            xd-qa-type="icon"
            xd-qa-name="Promo Code Alert"
            aria-label={expired ? (
                `Promo Code '${code}' has expired. Please 'Edit Order' and adjust payment to reconcile the new balance.`
            ) : (
                `Promo Code '${code}' expires in ${mapCountdownAsLabel(countdown)}! This order will lose its discount if not approved before then.`
            )}
            className={cx("alert-icon", {'yellow': !expired, 'red': expired})}
        >
                <FontAwesomeIcon icon={faExclamationCircle}/>
        </i>
    ),
);

const mapCountdownAsLabel = ({days, hours}) => {
    const parts = [`${hours} ${hours > 1 ? "hours" : "hour"}`];
    if (days > 0)
        parts.unshift(`${days} ${days > 1 ? "days" : "day"}`);
    return parts.join(", ");
};

